
(function(template){
define('vue!app/views/vue/app',[
    "Vue",
    'helpers',
    'vuex',
    "vue!./components/packageDivComponent/stepper",
    "vue!./components/cartComponent/cart",
    "vue!basicComponents/messageContainer",
    "vue!./components/cartComponent/cartBody/scheduleButtonComponent",
    "vue!./components/cartComponent/addGuestComponent/container", "vue!./components/packageDivComponent/stepperHeader", 'moment'

], function (Vue, helpers, vuex, stepper, cart, messageContainer, schedulebtn, logIn, stepperHeaderComponent, moment) {
    return {
        name: 'App',
        template: template,
        components: {
            'vue-stepper': stepper,
            'vue-cart': cart,
            'message-container': messageContainer,
            "schedule-btn": schedulebtn,
            "log-in": logIn,
            'stepper-header-component': stepperHeaderComponent
        },
        methods: {
            handleResize: function () {

                var bool = window.innerWidth > 800 ? true : false;
                this.$store.commit('changeDesktopMode', bool);
                this.$store.commit("setshowSummaryOnSideBar", bool);
            },
            scrollToCalender: function () {
                !this.desktopMode ? window.scrollTo({
                    top: 104,
                    behavior: 'smooth'
                }) : null
            },
            handleStickyPostion: function () {
                var sticky_cart = this.$refs["cart"].offsetTop + 10
               
                // console.log("49", window.pageYOffset, sticky_cart)
                if (window.pageYOffset >= sticky_cart)  this.sticky = true
                else   this.sticky = false
               
                if (window.pageYOffset >= 110)  this.sticky_date = true
                else this.sticky_date = false

                if (window.pageYOffset >= 63) this.sticky_schedule = true
                else this.sticky_schedule = false

                if (this.activeStep == 0) {
                    if (window.pageYOffset <= (document.scrollingElement?document.scrollingElement.scrollHeight - document.documentElement.clientHeight - 10 : 0)) {
                        this.sticky_schedule_Btn = true;
                    } else this.sticky_schedule_Btn = false
                  
                } else if (this.activeStep == 1) {
                    if (window.pageYOffset <= (document.scrollingElement?document.scrollingElement.scrollHeight - document.documentElement.clientHeight - 9:0)) {
                        this.sticky_schedule_Btn = true
                    }
                }
            },
        },
        computed: _.extend(
            vuex.mapState([
                "status",
                "errorMessage", "selectedDateOnDateBar", "desktopMode", "mobileViewMessages", 'activeUser', "currentlyEditingService", "users", "activeStep", "showLoaderForBooking", "is_body_blur", "selectedTimeOnTimePicker", 'loggedInUser','showLoaderOnStaffChange','guestProfiles', 'OTBactive'
            ]), {
                globalStatus: function () {
                    return _.values(this.localStrings.stepper.body.schedule.status).slice(0, 5);
                },
                username: function () {
                    return Object.keys(this.users)[this.activeUser]
                },
                itemId: function () {
                    return Object.keys(this.users[this.username] || {})[
                        this.currentlyEditingService]
                },
                allserviceNotBooked: function () {
                    vm = this
                    return _.keys(this.users).some(function (user) {
                        return _.values(vm.users[user]).some(function (item) {
                            return !item.SpaFolioItemId
                        });
                    })
                },
                
                ActiveServiceBookingStatus: function () {
                    return !!(this.users[this.username][this.itemId]||{}).SpaFolioItemId
                },
                ActiveServiceName: function () {
                    if (this.itemId) {
                        return this.users[this.username][this.itemId].serviceName
                    }
                },
                selectedDate: function () {
                    vm = this
                    return moment(vm.selectedDateOnDateBar,
                        vm.localStrings.stepper.body.schedule.dateBarDaysFormat).format("ddd, MMM D ")
                }
            }),
        data: function () {
            return {
                sticky: false,
                sticky_date: false,
                sticky_schedule_Btn: false,
                sticky_note: false,
                sticky_schedule: false
            };
        },
        mounted: function () {
            var vm = this;
                // vm.$store.commit('setReviewScreenBookingDetails',{})//empty booking details for review screen before it set again
               helpers.updateCalender()
            // });
            helpers.updateNavBar();
            vm.$store.commit("setIsBodyBlur", false)
            window.addEventListener('scroll', this.handleStickyPostion);
            var location = helpers.getSelectedLocation();
            if(location.PMSRoomMandatory == 'Y') {
                app.models.systemModel.validatePMSBeforeSpa(location.LocationName).done(function(r_pbs){
                    if (r_pbs) {
                        vm.$store.commit('addGlobalMessage',{type: 'info', message:app.localization.spaBooking.pmsbeforespa.notice, noTimeOut:true });
                    }
                });
            }
            if(app.data.CustomerId && !app.data.userLoggedIn){
                this.$store.commit('setTempUser');
            }
            
        },
        beforeMount: function () {
            var self = this;
            self.$store.commit('setOTBactive', Customization.spaBooking.onetimeBookerLocations && _.isArray(Customization.spaBooking.onetimeBookerLocations) && Customization.spaBooking.onetimeBookerLocations.indexOf(app.data["selected/spa/spaLocations/SpaLocation/"]) > -1);
            self.$store.commit('setActiveSpaLocation', app.data["selected/spa/spaLocations/SpaLocation/"]);
            window.addEventListener('resize', self.handleResize)
            window.addEventListener('scroll', self.handleStickyPostion);
            self.handleResize();
            // //As a part of age restriction, it is we need to call fetchCustomerProfile to fetch loggedIn user detail which has birthdate in it. Clear the schedulebtnValidation list to give it a fresh start
            // if(app.data.userLoggedIn){ helpers.fetchLoggedInCustomerProfile().then(function (profile) {
            //     if (profile.Customer) {
            //         var modifedProfile = _.extend({}, self.guestProfiles[profile.Customer[0].CustomerId], profile.Customer[0])
            //         self.$store.commit('addGuestProfile', modifedProfile)

            //         delete self.guestProfiles[profile.Customer[0].CustomerId].requireDatePicker
            //     }
            // })}
        
        },
        destroyed: function () {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('scroll', this.handleStickyPostion);
        }

    };
});
})('<div class="test"> <message-container v-if="desktopMode"></message-container> <div class="booking-loader" v-show="showLoaderForBooking || showLoaderOnStaffChange"> <div></div> <p>{{status}}</p> </div> <div id="app" class="spa-pkg-tpl" :class="showLoaderForBooking || showLoaderOnStaffChange?\'blur-while-booking\':null"> <div class="stepper-container" :class="[sticky? \'sticky_cart\': \'\',!loggedInUser?\'sticky-header-not-logged-in\':null, OTBactive && (this.$store.state.status != \'E\') ? \'sp-booker\' : null]" ref="cart"> <div v-if=" !desktopMode && activeStep!=2" :class="mobileViewMessages[\'success\']?\' alert-success mobileMessage\':mobileViewMessages[\'fail\']?\'mobileErrorMessage alert-error .control-group.error\':null" > {{mobileViewMessages[\'success\']||mobileViewMessages[\'fail\']}} </div> <vue-stepper :class="[is_body_blur?\'blur-body\':null,sticky_schedule?\'sticky-schedule-fix\':null]"></vue-stepper> <vue-cart :class="[sticky? \'sticky_cart\': \'\',activeStep==0?\'service-picker-screen-cart\':\'\']"></vue-cart> <div v-show="!desktopMode && activeStep==1" @click="scrollToCalender" class="mobile_view_date_sticky_bar" :class="[sticky_date? \'sticky_mobile_view_date_sticky_bar sticky_header_shadow\': \'\',sticky_date &&!loggedInUser?\'mobile_date_sticky_bar_notloggedIn\':null]"> <i class="fas fa-calendar-alt" aria-hidden="true"></i><span>{{selectedDate }}</span><span class="sticky_mobile_view_time_on_bar" v-show="selectedTimeOnTimePicker">| <i class="far fa-clock"></i>{{ selectedTimeOnTimePicker }}</span></div> <div v-if="!desktopMode && activeStep==1" class="mobile_view_service_sticky_bar" :class="sticky_schedule? \'sticky_mobile_view_service_sticky_bar\': \'\'"> <stepper-header-component></stepper-header-component> </div> </div> </div> </div>');
